// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../rescript/lib/es6/curry.js";
import * as Caml_option from "../../../../../rescript/lib/es6/caml_option.js";
import * as Env$Catalyst from "../Env.bs.js";
import * as React from "@sentry/react";
import * as GenericResponseMapper$Catalyst from "./GenericResponseMapper.bs.js";

function parseSuccess(response) {
  return response.json().then(function (result) {
              return Promise.resolve({
                          TAG: /* Success */0,
                          _0: result
                        });
            });
}

function parseUnprocessedError(response) {
  return response.json().then(function (result) {
              return Promise.resolve({
                          TAG: /* UnprocessedEntity */2,
                          _0: result
                        });
            });
}

function parseNotAcceptableError(response) {
  return response.json().then(function (result) {
              return Promise.resolve({
                          TAG: /* NotAcceptableEntity */3,
                          _0: result
                        });
            });
}

function parseDataConflictError(response) {
  return response.json().then(function (result) {
              return Promise.resolve({
                          TAG: /* DataConflict */7,
                          _0: result
                        });
            });
}

function execute(response) {
  var match = response.status;
  if (match >= 205) {
    if (match >= 303) {
      switch (match) {
        case 401 :
            return Promise.resolve({
                        TAG: /* Unauthorized */4,
                        _0: {
              "title": "Unauthorized",
              "message": "You are not authenticated for the operation"
            }
                      });
        case 403 :
            return Promise.resolve({
                        TAG: /* Forbidden */5,
                        _0: {
                "title": "Forbidden",
                "message": "You are not authorized for the operation"
              }
                      });
        case 406 :
            return parseNotAcceptableError(response);
        case 409 :
            return parseDataConflictError(response);
        case 402 :
        case 404 :
        case 405 :
        case 407 :
        case 408 :
        case 410 :
        case 411 :
        case 412 :
        case 413 :
        case 414 :
        case 415 :
        case 416 :
        case 417 :
        case 418 :
        case 419 :
        case 420 :
        case 421 :
            break;
        case 422 :
            return parseUnprocessedError(response);
        default:
          
      }
    } else if (match >= 301) {
      return parseSuccess(response);
    }
    
  } else if (match >= 202) {
    if (match >= 204) {
      return Promise.resolve({
                  TAG: /* SuccessWithNoContent */1,
                  _0: {
              "title": "Success",
              "message": "The operation was successfully completed"
            }
                });
    }
    
  } else if (match >= 200) {
    return parseSuccess(response);
  }
  return Promise.resolve({
              TAG: /* InternalServerError */6,
              _0: {
              "title": "Internal Server Error",
              "message": "Something went wrong"
            }
            });
}

var ResponseWrapper = {
  parseSuccess: parseSuccess,
  parseUnprocessedError: parseUnprocessedError,
  parseNotAcceptableError: parseNotAcceptableError,
  parseDataConflictError: parseDataConflictError,
  execute: execute
};

function execute$1(data) {
  if (typeof data === "number") {
    switch (data) {
      case /* FailedToFetch */1 :
          return GenericResponseMapper$Catalyst.FailedToFetchErrorHandler.execute(undefined);
      case /* RequestCancelled */2 :
          return GenericResponseMapper$Catalyst.RequestCancelledErrorHandler.execute(undefined);
      default:
        return ;
    }
  } else {
    switch (data.TAG | 0) {
      case /* UnprocessedEntity */2 :
          return GenericResponseMapper$Catalyst.UnprocessedErrorHandler.execute(data._0);
      case /* NotAcceptableEntity */3 :
          return GenericResponseMapper$Catalyst.NotAcceptableErrorHandler.execute(data._0);
      case /* Unauthorized */4 :
          var hostname = Env$Catalyst.getHostName(undefined);
          var url = hostname + "/administrators/sign_in";
          window.open(url, "_parent");
          return ;
      case /* Forbidden */5 :
      case /* InternalServerError */6 :
          return GenericResponseMapper$Catalyst.ForbiddenErrorHandler.execute(data._0);
      case /* DataConflict */7 :
          return GenericResponseMapper$Catalyst.DataConflictErrorHandler.execute(data._0);
      case /* UnhandledError */9 :
          var error = data._0;
          console.log("---response-handler---");
          console.log(error);
          React.captureException(error);
          return ;
      default:
        return ;
    }
  }
}

var DefaultErrorConverter = {
  execute: execute$1
};

function ResponseConverter(ResponseConverterConfig, ErrorConverterConfig) {
  var execute = function (response) {
    if (typeof response !== "number") {
      switch (response.TAG | 0) {
        case /* Success */0 :
        case /* SuccessWithNoContent */1 :
            return Caml_option.some(Promise.resolve({
                            TAG: /* Ok */0,
                            _0: Curry._1(ResponseConverterConfig.execute, response._0)
                          }));
        default:
          
      }
    }
    var error = Curry._1(ErrorConverterConfig.execute, response);
    if (error !== undefined) {
      return Caml_option.some(Promise.resolve({
                      TAG: /* Error */1,
                      _0: Caml_option.valFromOption(error)
                    }));
    }
    
  };
  return {
          execute: execute
        };
}

function DriverResponseConverter(ResponseConverterConfig, ErrorConverterConfig) {
  var execute = function (response, msisdn) {
    var exit = 0;
    if (typeof response === "number") {
      exit = 2;
    } else {
      switch (response.TAG | 0) {
        case /* Success */0 :
        case /* SuccessWithNoContent */1 :
            exit = 1;
            break;
        default:
          exit = 2;
      }
    }
    switch (exit) {
      case 1 :
          return Caml_option.some(Promise.resolve({
                          TAG: /* Ok */0,
                          _0: Curry._2(ResponseConverterConfig.execute, response._0, msisdn)
                        }));
      case 2 :
          var error = Curry._1(ErrorConverterConfig.execute, response);
          if (error !== undefined) {
            return Caml_option.some(Promise.resolve({
                            TAG: /* Error */1,
                            _0: Caml_option.valFromOption(error)
                          }));
          } else {
            return ;
          }
      
    }
  };
  return {
          execute: execute
        };
}

export {
  ResponseWrapper ,
  DefaultErrorConverter ,
  ResponseConverter ,
  DriverResponseConverter ,
  
}
/* @sentry/react Not a pure module */
